import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { CLAIM_CODE_GET_DATA_BBM, INITIAL_PAGINATION } from "../../constant";
import { getTableConfigBBM } from "../section/config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ModalNomorBBM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: INITIAL_PAGINATION,
      dataTable: [],
    };
  }

  componentDidMount() {
    this.fetchDataBBM();
  }

  fetchDataBBM = async (value) => {
    const { setError, onTriggerLoading, selectedCabang } = this.props;

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getListBBMManagementClaim,
      menuName: "Management Claim",
      setError: setError,
      args: {
        kodeCabang: selectedCabang?.value,
        specialCategory: CLAIM_CODE_GET_DATA_BBM,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
      }));
    }
  };

  getTableConfig = () => {
    const { setValue, onClickClose } = this.props;

    return getTableConfigBBM({
      onSelect: (val) => {
        setValue("noBBM", val);
        onClickClose();
      },
    });
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { pagination, dataTable } = this.state;
    return (
      <SimpleModal
        title="List Data Nomor BBM"
        visible={visible}
        onClickClose={onClickClose}
        content={
          <React.Fragment>
            <ModalContainer>
              <SimpleDataTable
                key={`${dataTable?.length}-${pagination.page}`}
                data={dataTable}
                columns={this.getTableConfig()}
                toCount={dataTable?.length}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
              />
            </ModalContainer>
          </React.Fragment>
        }
      />
    );
  }
}

export default ModalNomorBBM;
